// extracted by mini-css-extract-plugin
export default {"header":"room_member_modal_header__RLIkB","label":"room_member_modal_label__ffV6C","value":"room_member_modal_value__QSWdi","divider":"room_member_modal_divider__oDsi5"};